import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Input } from 'antd';
import React, { Component } from 'react';
import { IIFC } from 'react-iifc';
import { useMediaQuery } from 'react-responsive';
import MobileFooter from '../../Component/Common/Profile/MobileFooter';
import RatingsService from '../../Service/RatingsService';
import { toastError, toastOnConfirmChanges } from '../../SweetAlertUtil/util';
import Loader from '../Common/Loader';
import PageHeaderTitle from '../Common/Profile/PageHeaderTitle';
import BaseRatingForm from './BaseRatingForm';
import RatingStars from './ratingStars';
import Session from '../../Service/Session';
import { capitalizeFirstLetter, convertToPhilippinesTime } from '../../AppUtil/AppUtil';
import Swal from 'sweetalert2';
import { hot } from 'react-hot-loader';

const { TextArea } = Input;

const { MOBILE } = window.AppConfig.SCREEN_SIZE;

class EditRating extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,

			newData: {
				value:
					this.props.headingName === 'label.borrower'
						? this.props.ratingData?.borrower_rating
						: this.props.ratingData?.lender_rating || null,

				app_overall_experience:
					this.props.headingName === 'label.borrower'
						? this.props.ratingData?.app_overall_experience
						: this.props.ratingData?.app_overall_experience_lender || null,
				app_user_friendliness:
					this.props.headingName === 'label.borrower'
						? this.props.ratingData?.app_user_friendliness
						: this.props.ratingData?.app_user_friendliness_lender || null,
				app_customer_service:
					this.props.headingName === 'label.borrower'
						? this.props.ratingData?.app_customer_service
						: this.props.ratingData?.app_customer_service_lender || null,
				recommend_to_a_friend:
					this.props.headingName === 'label.borrower'
						? this.props.ratingData?.recommend_to_a_friend
						: this.props.ratingData?.recommend_to_a_friend_lender || null,
				message:
					this.props.headingName === 'label.borrower'
						? this.props.ratingData?.comment_or_suggestion
						: this.props.ratingData?.comment_or_suggestion_lender || ''
			},
			listData: {},
			name: this.props.loanObject.name,
			message: '',
			_disableSaveButton: true,
			role: '',
			comment: '',
			_isRated: false
		};
	}

	ifLoanIdNotExistCreate = async () => {
		this.startLoader();
		try {
			const result = await RatingsService.listRatingByLoanId(this.props.loanObject.id);
			const loan = this.props.loanObject;
			const currentUser = Session.get('CURRENT_USER_INFO');

			if (
				(currentUser.username == result[0]?.borrower_id && result[0]?.lender_rating) ||
				(currentUser.username == result[0]?.lender_id && result[0]?.borrower_rating)
			) {
				Swal.fire({
					text: 'You have already rated this loan.',
					icon: 'warning',
					allowOutsideClick: false,
					customClass: 'otp_message_success'
				});

				this.setState({ _isRated: true });
			}

			this.setState({
				newData: {
					value:
						this.props.headingName === 'label.borrower'
							? result[0]?.borrower_rating
							: result[0]?.lender_rating || 0,

					app_overall_experience:
						this.props.headingName === 'label.borrower'
							? result[0]?.app_overall_experience
							: result[0]?.app_overall_experience_lender || 0,
					app_user_friendliness:
						this.props.headingName === 'label.borrower'
							? result[0]?.app_user_friendliness
							: result[0]?.app_user_friendliness_lender || 0,
					app_customer_service:
						this.props.headingName === 'label.borrower'
							? result[0]?.app_customer_service
							: result[0]?.app_customer_service_lender || 0,
					recommend_to_a_friend:
						this.props.headingName === 'label.borrower'
							? result[0]?.recommend_to_a_friend
							: result[0]?.recommend_to_a_friend_lender || 0,
					message:
						this.props.headingName === 'label.borrower'
							? result[0]?.comment_or_suggestion
							: result[0]?.comment_or_suggestion_lender || ''
				}
			});

			if (!(result.length > 0)) {
				let payload;
				if (this.props.loanObject?.loan_type === 'BORROW') {
					payload = {
						borrower_id: this.props.loanObject?.created_by,
						borrower_first_name:
							capitalizeFirstLetter(this.props.loanObject?.created_by_user?.first_name) || null,
						borrower_last_name:
							capitalizeFirstLetter(this.props.loanObject?.created_by_user?.last_name) || null,
						lender_id: this.props.loanObject?.accepted_by,
						lender_first_name:
							capitalizeFirstLetter(this.props.loanObject?.accepted_by_user?.first_name) || null,
						lender_last_name:
							capitalizeFirstLetter(this.props.loanObject?.accepted_by_user?.last_name) || null,
						loan_id: this.props.loanObject?.id,
						borrower_rating: null,
						lender_rating: null,
						app_overall_experience: null,
						app_user_friendliness: null,
						app_customer_service: null,
						recommend_to_a_friend: null,
						comment_or_suggestion: '',

						app_overall_experience_lender: null,
						app_user_friendliness_lender: null,
						app_customer_service_lender: null,
						recommend_to_a_friend_lender: null,
						comment_or_suggestion_lender: ''
					};
				}
				if (this.props.loanObject?.loan_type === 'LEND') {
					payload = {
						borrower_id: this.props.loanObject?.accepted_by,
						borrower_first_name:
							capitalizeFirstLetter(this.props.loanObject?.accepted_by_user?.first_name) || null,
						borrower_last_name:
							capitalizeFirstLetter(this.props.loanObject?.accepted_by_user?.last_name) || null,

						lender_id: this.props.loanObject?.created_by,
						lender_first_name:
							capitalizeFirstLetter(this.props.loanObject?.created_by_user?.first_name) || null,
						lender_last_name:
							capitalizeFirstLetter(this.props.loanObject?.created_by_user?.last_name) || null,
						loan_id: this.props.loanObject?.id,
						borrower_rating: null,
						lender_rating: null,
						app_overall_experience: null,
						app_user_friendliness: null,
						app_customer_service: null,
						recommend_to_a_friend: null,
						comment_or_suggestion: '',

						app_overall_experience_lender: null,
						app_user_friendliness_lender: null,
						app_customer_service_lender: null,
						recommend_to_a_friend_lender: null,
						comment_or_suggestion_lender: ''
					};
				}

				await RatingsService.setUserRating(payload);
			}
			this.stopLoader();
		} catch (error) {
			this.stopLoader();
			console.log(error);
		}
	};

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	updateUserInfo = async ratingVal => {
		let payloadEdit;
		this.startLoader();

		try {
			if (this.props.headingName === 'label.borrower') {
				payloadEdit = {
					loan_id: this.props.loanObject.id,
					borrower_rating: ratingVal[0],

					app_overall_experience: ratingVal[1],
					app_user_friendliness: ratingVal[2],
					app_customer_service: ratingVal[3],
					recommend_to_a_friend: ratingVal[4],
					comment_or_suggestion: ratingVal[5],
					borrower_rated_at: convertToPhilippinesTime(new Date())
				};
			}
			if (this.props.headingName === 'label.lender') {
				payloadEdit = {
					loan_id: this.props.loanObject.id,

					lender_rating: ratingVal[0],

					app_overall_experience_lender: ratingVal[1],
					app_user_friendliness_lender: ratingVal[2],
					app_customer_service_lender: ratingVal[3],
					recommend_to_a_friend_lender: ratingVal[4],
					comment_or_suggestion_lender: ratingVal[5],
					lender_rated_at: convertToPhilippinesTime(new Date())
				};
			}

			const { data, status } = await RatingsService.replaceUserRating(payloadEdit);

			if (!status) {
				toastError(data);
			}
			this.props.closeEditScreen(ratingVal);
			this.stopLoader();
		} catch (error) {
			console.log(error);
			this.stopLoader();
		}
	};

	getComment(message) {
		this.setState({ comment: message });
	}

	onSubmitHandler = async e => {
		e.preventDefault();

		const {
			value,
			app_customer_service,
			app_overall_experience,
			app_user_friendliness,
			recommend_to_a_friend,
			message
		} = this.state.newData;

		this.getComment(message);
		const rating = [
			value,
			app_overall_experience,
			app_user_friendliness,
			app_customer_service,
			recommend_to_a_friend,
			message
		];

		toastOnConfirmChanges(
			this.updateUserInfo,
			rating,
			this.props.closeEditScreen,
			'Do you want to add this review?'
		);
	};

	componentDidMount() {
		if (this.props.headingName == 'label.borrower') {
			this.setState({ role: 'borrower' });
		}
		if (this.props.headingName == 'label.lender') {
			this.setState({ role: 'lender' });
		}
		this.getComment(this.state.newData.message);
		this.ifLoanIdNotExistCreate();
	}

	render() {
		const disabledButton =
			Object.values(this.state.newData).includes(0) ||
			Object.values(this.state.newData).includes(undefined) ||
			Object.values(this.state.newData).includes(null) ||
			Object.values(this.state.newData).includes(-1) ||
			Object.values(this.state.newData).includes('');

		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });

					return (
						<>
							<section className="edit_ratingform">
								<PageHeaderTitle
									title="Rating"
									isMobile={isMobile}
									onClick={this.props.backEditScreen}
									className="edit_rating p-x-16"
								/>

								<BaseRatingForm value={this.state.value} headingName={this.props.headingName}>
									<Grid item sm={12} xs={12} className="edit_rating_content">
										<Typography component="h1" variant="h5">
											Kindly rate the the following:
										</Typography>
									</Grid>

									<div className="num1">
										<Grid item sm={12} xs={12}>
											<Typography component="h1" variant="h5">
												1. {this.state.role.charAt(0).toUpperCase() + this.state.role.slice(1)}:{' '}
												{this.state.name}
											</Typography>
											<Typography component="p" variant="body1" className="para">
												{' '}
												for Loan ID:{' '}
												<span className="bold-important">
													{`LA${String(this.props.loanObject.id).padStart(5, '0')}`}
												</span>
											</Typography>
											<Grid item sm={12} xs={12}>
												{
													<RatingStars
														readOnly={this.state.comment}
														value={parseFloat(this.state.newData.value)}
														name="lender_or_borrower"
														max={5}
														onChange={(_event, newValue) => {
															this.setState({
																newData: {
																	...this.state.newData,
																	value: newValue
																}
															});
														}}></RatingStars>
												}
											</Grid>
										</Grid>
									</div>
									<div className="num2">
										<Grid item sm={12} xs={12}>
											<Typography component="h1" variant="h5">
												2. Lendami App
											</Typography>
											<Typography component="p" variant="body1" className="para">
												Overall experience
											</Typography>
											<Grid item sm={12} xs={12}>
												<RatingStars
													readOnly={this.state.comment}
													value={parseFloat(this.state.newData.app_overall_experience)}
													name="app_overall_experience"
													onChange={(_event, newValue) => {
														this.setState({
															newData: {
																...this.state.newData,

																app_overall_experience: newValue
															}
														});
													}}
													max={5}></RatingStars>
											</Grid>
											<Typography component="p" variant="body1" className="para">
												User-friendliness
											</Typography>
											<Grid item sm={12} xs={12}>
												<RatingStars
													readOnly={this.state.comment}
													value={parseFloat(this.state.newData.app_user_friendliness)}
													name="app_user_friendliness"
													max={5}
													onChange={(_event, newValue) => {
														this.setState({
															newData: {
																...this.state.newData,
																app_user_friendliness: newValue
															}
														});
													}}></RatingStars>
											</Grid>
											<Typography component="p" variant="body1" className="para">
												Customer-service
											</Typography>
											<Grid item sm={12} xs={12}>
												<RatingStars
													readOnly={this.state.comment}
													value={parseFloat(this.state.newData.app_customer_service)}
													name="app_customer_service"
													max={5}
													onChange={(_event, newValue) => {
														this.setState({
															newData: {
																...this.state.newData,
																app_customer_service: newValue
															}
														});
													}}></RatingStars>
											</Grid>
										</Grid>
									</div>
									<div className="num3">
										<Grid sm={12} xs={12}>
											<div style={{ display: 'flex' }}>
												<Typography component="h1" variant="h5" style={{ padding: '2px' }}>
													3.
												</Typography>
												<Typography component="h1" variant="h5" style={{ padding: '2px' }}>
													How likely are you to recommend LendAmi Application to a friend or
													colleague?
												</Typography>
											</div>
											<Grid item sm={12} xs={12} className="ten-stars">
												<RatingStars
													readOnly={this.state.comment}
													value={parseFloat(this.state.newData.recommend_to_a_friend)}
													name="recommend_to_a_friend"
													max={10}
													onChange={(_event, newValue) => {
														this.setState({
															newData: {
																...this.state.newData,
																recommend_to_a_friend: newValue
															}
														});
													}}></RatingStars>
											</Grid>
										</Grid>
									</div>
									<div className="num4">
										<Grid sm={12} xs={12}>
											<Typography component="h1" variant="h5">
												4. Comments/Suggestions
											</Typography>
											<Typography className="rating-message" component="p" variant="h6">
												{this.state._isRated && this.state.newData.message}
											</Typography>

											{!this.state._isRated ? (
												<TextArea
													name="comment_or_suggestion"
													className="textarea"
													allowClear
													// value={this.state.newData.message}
													maxLength={100}
													style={{
														height: 120,
														marginLeft: '25px',
														resize: 'none',
														borderRadius: '4px'
													}}
													onChange={(event, _newValue) => {
														this.setState({
															newData: {
																...this.state.newData,
																message: event.target.value
															}
														});
													}}
												/>
											) : null}
										</Grid>
									</div>
									{disabledButton && (
										<p style={{ color: 'red', textAlign: 'center', fontSize: '8px' }}>
											*Please provide rate and feedback
										</p>
									)}

									<MobileFooter
										hideContinueBtn={this.state._isRated}
										className="edit_rating_footer"
										disabled={disabledButton}
										loading={this.state._isLoading}
										hasNext={true}
										onClick={this.props.backEditScreen}
										onSubmit={this.onSubmitHandler}
										textButtonContinue="SUBMIT"
									/>
								</BaseRatingForm>
								{this.state._isLoading && <Loader />}
							</section>
						</>
					);
				}}
			</IIFC>
		);
	}
}

export default hot(module)(EditRating);
